<template>
    <TagSetting :referenceType="'Tags - Case Requestor'"/>
</template>
<script>
    const TagSetting = () => import("./list.vue")
    export default {
        name: 'case-setting-requestor-tags',
        components: {
            TagSetting
        },
        data () {
            return {}
        },
        methods:{}
    }
</script>
